import { render, staticRenderFns } from "./CompanyFace.vue?vue&type=template&id=595d909e&scoped=true&"
import script from "./CompanyFace.vue?vue&type=script&lang=js&"
export * from "./CompanyFace.vue?vue&type=script&lang=js&"
import style0 from "./CompanyFace.vue?vue&type=style&index=0&id=595d909e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "595d909e",
  null
  
)

export default component.exports